<template>
  <div class="cpt-unlock">
    <div :class="$utils.isMobile() ? 'unlock-m' : 'unlock'">
      <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ unlockData.titleEn }}</div>
      <div class="title tit">{{ unlockData.title }}</div>
      <cpt-divider></cpt-divider>
      <div class="content">
        <div
          class="item"
          v-for="item in unlockData.list"
          :key="item.id"
        >
          <div class="img-box">
            <img class="img" :src="item.img" alt="">
          </div>
          <div class="text">
            <div class="top-box">
              <div class="item-title">{{ item.title }}</div>
              <img class="img" src="../assets/icon-unlock.png" alt="">
            </div>
            <div :class="$i18n.locale == 'en-US' ? 'txt-en' : 'txt'">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <div class="more">
        <router-link to="/service">
          <div class="view-more">
            <div class="text">{{ $t('acm_learn_more') }}</div>
            <img class="icon" src="../assets/arrow-blue.png" alt="">
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import cptDivider from './cpt-divider.vue';
export default {
  name: 'cpt-unlock',
  components: {
    cptDivider
  },
  data() {
    return {
      unlockData: this._contentData.unlockData
    }
  },
  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-unlock{
  width: 100%;
  display: flex;
  justify-content: center;
  .unlock{
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .content{
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 578px;
        border: 1px solid #407ea0;
        border-radius: 15px;
        margin: 10px;
        .img-box{
          img{
            border-radius: 15px 15px 0 0;
            width: 100%;
            // height: 260px;
            display: block;
          }
        }
        .text{
          padding: 35px;
          .top-box{
            display: flex;
            justify-content: space-between;
            .item-title{
              font-size: 28px;
              color: #333;
              // font-family: MiSans-Medium;
            }
            .img{
              height: 100%;
            }
          }
          .txt{
            font-size: 24px;
            color: #666;
            // font-family: MiSans-Normal;
          }
          .txt-en{
            font-size: 22px;
            color: #666;
            // font-family: MiSans-Normal;
          }
        }
      }
    }
    .more{
      .view-more{
        border: 1px solid #407ea0;
        display: flex;
        width: max-content;
        margin: 48px 0 30px;
        .text{
          color: #fff;
          font-size: 24px;
          // font-family: MiSans-Normal;
          background: #407ea0;
          padding: 10px 40px;
        }
        .icon{
          background: #fff;
          width: auto;
          padding: 10px 30px;
        }
      }
    }
  }
  .unlock-m{
    // max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    .tit-en{
      color: rgba(51, 51, 51, 0.3);
      text-align: center;
    }
    .tit{
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .content{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item{
        width: calc(50% - 12px);
        border: 1px solid #407ea0;
        border-radius: 8px;
        margin: 10px 0;
        letter-spacing: normal;
        .img-box{
          img{
            border-radius: 8px 8px 0 0;
            width: 100%;
            // height: 260px;
            display: block;
          }
        }
        .text{
          padding: 5px 10px 10px;
          .top-box{
            display: flex;
            justify-content: space-between;
            .item-title{
              font-size: 8px;
              color: #333;
              // font-family: MiSans-Demibold;
              padding: 5px 0;
            }
            .img{
              height: 16px;
            }
          }
          .txt{
            font-size: 7px;
            color: #666;
            // font-family: MiSans-Normal;
          }
          .txt-en{
            font-size: 7px;
            color: #666;
            // font-family: MiSans-Normal;
          }
        }
      }
    }
    .more{
      .view-more{
        border: 1px solid #407ea0;
        display: flex;
        width: max-content;
        margin: 48px 0 30px;
        .text{
          color: #fff;
          font-size: 10px;
          // font-family: MiSans-Normal;
          background: #407ea0;
          padding: 5px 20px;
        }
        .icon{
          background: #fff;
          height: 14px;
          padding: 5px 15px;
        }
      }
    }
  }
}
</style>